module.exports = __webpack_public_path__ + "img/20210420_122223.6f6d6ec7.jpg";